import React, {Component} from "react";  import config from 'react-global-configuration';
import {Bar} from 'react-chartjs-2';
import axios from "axios";
import jwt_decode from "jwt-decode";
import {Scrollbars} from 'react-custom-scrollbars';
import Moment from "react-moment";
import Select from 'react-select';
import {BeatLoader} from 'react-spinners';
import {css} from "@emotion/core";
import posIcon from "../assets/img/pos.png";
import {connect}  from  "react-redux";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:right;
`;

function  generateData() {
    //alert("dasdad");
}

function formatNumber (num) {
    //return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    var n1, n2;
    num = num + '' || '';
    // works for integer and floating as well
    n1 = num.split('.');
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    num = n2 ? n1 + '.' + n2 : n1;
    return num;
}
function getMonth(date) {
    var month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
}
const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
var monthDefault = [];
    let dateDefault = new Date();
    let monthd = dateDefault.setMonth(dateDefault.getMonth() -1);
    dateDefault = dateDefault.toDateString();
    dateDefault = new Date(dateDefault);
    let monthDefaults = getMonth(dateDefault);
    let yearDefault= dateDefault.getFullYear();
    let monthNamed = monthNames[dateDefault.getMonth()];
    monthDefault.push({ value: monthDefaults+yearDefault, label: monthNamed+' '+yearDefault});

class InvoiceDashboard extends Component {
    state= {
        users_notifications:[],
        invoice_history:[],
        invoice_history_data:{},
        invoice_month:monthDefault[0].value,
        active_terminals:'',
        invoice_amount:'',
        loading: true,
        monthOptions:[],
        label_month:monthDefault[0].label
    };
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        generateData();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.getInvoiceMonth();
        this.getInvoiceMonthly(this.state.invoice_month);
        this.get_notifications(decoded);
        this.get_invoice_history();
    }
    getInvoiceMonth(){
        axios.get(config.get('API_URL')+'/invoice/get_months/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log("monthhhhhhh");
            //console.log(response);
            this.enabled_months(response.data);
        });
    }
    enabled_months(emonths) { //alert(emonths);
        this.setState({
            monthOptions:[]
        });
        var defaultSelectedArray = [];
        var monthOptionsArray= [];
        for(var i=0; i<=11; i++){
            let date2 = new Date();
            let monthd = date2.setMonth(date2.getMonth() -i);
            date2 = date2.toDateString();
            date2 = new Date(date2);
            let month2 = getMonth(date2);
            let year2 = date2.getFullYear();
            let monthName2 = monthNames[date2.getMonth()];
            var isDisable = true;
            if(emonths.includes(month2+year2)===true){
                isDisable = false;
                defaultSelectedArray.push({ value: month2+year2, label: monthName2+' '+year2})
            }
            //alert(month2+year2);
            monthOptionsArray.push({ value: month2+year2, label: monthName2+' '+year2, isDisabled: isDisable})
        }
        this.setState({
           monthOptions:monthOptionsArray
        })
    }
    get_notifications(decoded){
        axios.get(config.get('API_URL')+'/masterdata/all_notifications/', {
            params: {
                user_id: decoded._id
            },
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            console.log("notifications");
            console.log(response);
            this.setState({
                users_notifications:response.data
            })
        }).catch(err => {
            console.log(err);
        });
    }
    getInvoiceMonthly(month){
        this.setState({
            active_terminals:'',
            invoice_amount:'',
            loading:true
        });
        axios.get(config.get('API_URL')+'/invoice/get_invoice_amount/', {
            params: {
                month: month
            },
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => { console.log(response);
            if(Array.isArray(response.data.data) && response.data.data.length) {
                this.setState({
                    invoice_amount: response.data.data[0]['Total Invoice Amount'],
                    active_terminals: response.data.data[0]['Total Active Terminals']
                })
            }
            this.setState({ loading:false})
        }).catch(err => {
            console.log(err);
            this.setState({ loading:false})
        });
    }
    changeInvoiceMonth(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        const label = optionSelected === null ? '' : optionSelected.label;
        //alert(label);
        this.setState({
            invoice_month: value,
            label_month: label
        });
        this.getInvoiceMonthly(value);
        this.get_invoice_history();
    }
    get_invoice_history(){
        axios.get(config.get('API_URL')+'/invoice/invoice-history/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            console.log(response);
            var labels = [];
            var month_val = [];
            var bColor = [];
            response.data.data.map((value, index) => {
                if(this.state.label_month==value['For Month']) {
                    bColor.push('#008cdd')
                } else {
                    bColor.push('#1DC7EA')
                }
                labels.push(value['For Month']);
                month_val.push(value['Invoice Amount']);

            });
            console.log(labels);
            var data = {
                labels: labels,
                datasets: [
                    {
                        label: 'Invoice History',
                        backgroundColor: bColor,
                        borderColor: '#008cdd',
                        borderWidth: 1,
                        hoverBackgroundColor: '#008cdd',
                        hoverBorderColor: '#1DC7EA',
                        data: month_val
                    }
                ]
            };
            this.setState({
                invoice_history_data :data,
                invoice_history:response.data,
            });

        }).catch(err => {
            console.log(err);
        });
    }
    // createLegend(json) {
    //     var legend = [];
    //     for (var i = 0; i < json["names"].length; i++) {
    //         var type = "fa fa-circle text-" + json["types"][i];
    //         legend.push(<i className={type} key={i} />);
    //         legend.push(" ");
    //         legend.push(json["names"][i]);
    //     }
    //     return legend;
    // }
    render() {
        let notificationTexts = '';
        const customStyles = {
            // control: provided => ({
            //     ...provided,
            //     padding:"0px",
            //     minHeight: "15px",
            // }),
            // indicatorsContainer: provided => ({
            //     ...provided,
            //     height: "23px"
            // }),
            // clearIndicator: provided => ({
            //     ...provided,
            //     padding: "5px"
            // }),
            // dropdownIndicator: provided => ({
            //     ...provided,
            //     padding: "5px"
            // }),
            // valueContainer: base => ({
            //     ...base,
            //     padding: '0px 6px'
            // }),

        };
        if(Array.isArray(this.state.users_notifications) && this.state.users_notifications.length) {
            notificationTexts = this.state.users_notifications.map((val, i) => {
                return (
                    <tr key={i + 1}>
                        <td><span className="noti-date"> <Moment format='MMMM Do YYYY, h:mm:ss a'>{val.created_at}</Moment> :</span> {val.message}</td>
                    </tr>
                );
            });
        }
        else{
            notificationTexts =
                (
                    <tr>
                        <td>There is no notification</td>
                    </tr>
                );
        }
        return (
          
            <div className="content">
                <div className="container-fluid">
                    <div className="row top10">
                        <div className="col-lg-4 col-sm-6">
                            <div className="card card-stats invoice-dash">
                                <div className="content">
                                    <label >Select Month </label>
                                    <Select name="month"
                                            styles={customStyles} className="chainLists w-100"
                                            isClearable={false}
                                            onChange={this.changeInvoiceMonth.bind(this)}
                                            options={this.state.monthOptions}
                                            defaultValue={monthDefault[0]}
                                            placeholder="Months"
                                    />
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="card card-stats">
                                <div className="content">
                                    <div className="row">
                                        <div className="col-xs-3">
                                            <div className="icon-big text-center icon-warning"><i
                                                className="pe-7s-wallet text-success"></i></div>
                                        </div>
                                        <div className="col-xs-9">
                                            <div className="numbers"><p>Total Invoice Amount </p>{formatNumber(this.state.invoice_amount)}
                                                {this.state.loading === false?
                                                < i className="kpi-currency"> (in Lakhs)</i>
                                                    : null
                                                }
                                                <BeatLoader
                                                    css={override}
                                                    sizeUnit={"px"}
                                                    size={12}
                                                    color={'#123abc'}
                                                    loading={this.state.loading}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="card card-stats">
                                <div className="content">
                                    <div className="row">
                                        <div className="col-xs-3">
                                            <div className="icon-big text-center icon-warning">
                                                <img src={posIcon} alt={posIcon} />
                                                {/*<i className="pe-7s-monitor text-success"></i>*/}
                                            </div>
                                        </div>
                                        <div className="col-xs-9">
                                            <div className="numbers"><p>Total Active UTIDs</p>{formatNumber(this.state.active_terminals)}
                                                <BeatLoader
                                                    css={override}
                                                    sizeUnit={"px"}
                                                    size={12}
                                                    color={'#123abc'}
                                                    loading={this.state.loading}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="card">
                                <div className="header"><h4 className="title">Notifications</h4>
                                    {/*<p className="category">All products including Taxes</p>*/}
                                </div>
                                <div className="content">
                                    <div className="table-full-width notificationDashboard">
                                        <Scrollbars style={{ height: 300 }}>
                                            <table className="table table-striped table-hover">
                                                <tbody>
                                                    {notificationTexts}
                                                </tbody>
                                            </table>
                                        </Scrollbars>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card">
                                <div className="header"><h4 className="title">Invoice History (Values in Lakhs)</h4>
                                    {/*<p className="category">All products including Taxes</p>*/}
                                </div>
                                <div className="content">
                                    <div className="table-full-width">
                                        <Bar
                                            data={this.state.invoice_history_data}
                                            width={100}
                                            height={300}
                                            options={{
                                                maintainAspectRatio: false
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<div className="">*/}
                    {/*    <div className="card">*/}
                    {/*        <div className="header"><h4 className="title">Invoice Breakup by Chain)</h4>*/}
                    {/*            /!*<p className="category">All products including Taxes</p>*!/*/}
                    {/*        </div>*/}
                    {/*        <div className="content">*/}
                    {/*            <div className="table-full-width">*/}
                    {/*                <HorizontalBar data={data1} height={100} />*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </div>
          
             );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( InvoiceDashboard);
